<template>
  <!--  <div>心律失常</div>-->
  <div style="margin: -14px -15px;overflow: hidden">

    <!--    医生信息-->
    <div class="review-doc">
      <div class="review-doc-title">医生信息</div>
      <div class="review-doc-content">
        <div class="review-doc-content-font">姓名 : {{dataForm.memberName}}</div>
        <div class="review-doc-content-font">医院 : {{dataForm.memberHospitalName}}</div>
        <div class="review-doc-content-font">上传时间 : {{dataForm.created_time}}</div>
      </div>
    </div>
    <!--    患者建档信息-->
    <div class="review-huan">
      <div class="review-huan-title">
        <div class="review-huan-title-huanzhe">患者建档信息</div>
        <div>
          <a-button type="primary" @click="preservation">保存患者信息</a-button>
        </div>
      </div>
      <div class="review-huan-content">
        <div class="review-huan-content-font">
          <div>性别 : </div>
          <div style="margin-left: 15px">
            <a-radio-group
                v-model="dataForm.patientSex"
                :options="SexPerson"
                @change="onChange" />
          </div>
        </div>
        <div class="review-huan-content-font-two">
          <div>年龄 :{{dataForm.patientAge}}</div>
          <div style="margin-left: 5px">年龄</div>
          <div style="margin-left: 15px">
            <a-date-picker
                placeholder="请选择性出生日期"
                :format="dateFormatList"
                @change="ageChange" /></div>
        </div>
      </div>
    </div>
    <!--    中间上传照片部分-->
    <div class="review-content">
      <!--      图片信息-->
      <div class="review-content-left">
        <div class="review-content-left-title">图片信息
          <a-button
              @click="refreshBtn"
              type="dashed" style="margin-left: 50%">刷新</a-button>
          <a-button
              @click="captchaBtn"
              type="primary" style="margin-left: 20px">打码</a-button>
        </div>
        <div class="review-content-left-font" style="margin-top: 30px">病例图片 ({{lenghtImage}}张)
        </div>
        <div style="height:1500px;width:100%;overflow:auto;">
          <div
              style="width: 100%"
              v-for="(item,index) in  dataForm.coding_image_list"
          >
            <img
                style="width: 95%;height: auto;margin: 10px 10px"
                :key="index"
                :src="dataForm.coding_image_list[index]"
            />
          </div>
        </div>
      </div>
      <!--      问卷信息-->
      <div class="review-content-right">
        <div class="review-content-right-title">问卷信息</div>
        <div style="width: 80%" v-show="dataForm.reject_reason">
          <div class="review-content-right-title-title">驳回原因</div>
          <div class="review-content-right-person" style="margin-top: 15px">
            {{dataForm.reject_reason}}
          </div>
        </div>
        <div style="width: 80%">
          <div class="review-content-right-title-title">患者基本信息</div>
          <div class="review-content-right-person" style="margin-top: 15px">
            <div class="review-content-right-person-sex">
              住院编号 : <a-input
                class="inputWitch"
                v-model="dataForm.template_content.resident_admit_note.patient_number"
            />
            </div>
            <a-button @click="examineBtn(dataForm.id,dataForm.template_content.resident_admit_note.patient_number)" type="primary">检查</a-button>
          </div>
          <div class="review-content-right-person" style="margin-top: 15px">
            <div class="review-content-right-person-name">
              患者年龄 : <a-input
                class="inputWitch"
                v-model="dataForm.template_content.resident_admit_note.age"
            />
            </div>
            <div style="margin-left: -30px">
              患者体重 : <a-input
                class="inputWitch"
                v-model="dataForm.template_content.resident_admit_note.height"
                placeholder="请输入体重"
            />
            </div>
          </div>
          <div class="review-content-right-person" style="margin-top: 15px">
            入院时间 :
            <a-date-picker
                :allowClear="false"
                v-model="dataForm.template_content.resident_admit_note.admission_time"
                style="width: 300px;margin-left: 10px"
                placeholder="Select month"
                @change="hospitalizedChange" />
          </div>
        </div>
        <div style="display: flex;width: 100%;margin-top: 20px">
          <div style="margin-left: 30px;display: flex">
            是否有高血压病史 :<a-radio-group
              style="margin-left: 20px"
              v-model="dataForm.template_content.resident_admit_note.is_hypertension"
              :options="quest_is_hypertension" />
          </div>
        </div>
        <div style="display: flex;width: 100%;margin-top: 20px">
          <div style="margin-left: 70px;display: flex">
            是否围术期 :<a-radio-group
              style="margin-left: 20px"
              v-model="dataForm.template_content.resident_admit_note.is_perioperative_period"
              :options="quest_is_perioperative_period" />
          </div>
        </div>

        <div style="width: 100%;margin-top: 20px">
          <div style="margin-left: 50px;">
            <div>入院诊断结果中心律失常类型 :</div>
            <a-checkbox-group
                v-model="dataForm.template_content.resident_admit_note.arrhythmia_type"
                style="width: 350px;margin-left: 80px"
                @change="checkboxChange">
              <a-row>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="窦速">
                    窦速
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="房速">
                    房速
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="房颤/房扑">
                    房颤/房扑
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="室速">
                    室速
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="室上性心动过速">
                    室上性心动过速
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="室速/室颤⻛暴">
                    室速/室颤⻛暴
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
        </div>

        <div style="width: 100%;margin-top: 20px">
          <div style="margin-left: 50px;">
            <div>其它诊断结果或合并疾病类型 :</div>
            <a-checkbox-group
                v-model="dataForm.template_content.resident_admit_note.types_of_cd"
                style="width: 350px;margin-left: 80px"
                @change="checkboxChange">
              <a-row>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="慢性心衰">
                    慢性心衰
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="急性冠脉综合征ACS">
                    急性冠脉综合征ACS
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="急性心衰">
                    急性心衰
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="急性心梗">
                    急性心梗
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="射血分数保留心衰">
                    射血分数保留心衰
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="其它">
                    其它
                  </a-checkbox>
                </a-col>
                <a-col :span="12" style="margin-top: 10px;">
                  <a-checkbox value="射血分数降低心衰">
                    射血分数降低心衰
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
        </div>

        <div style="width: 100%;margin-top: 20px;margin-left: 50px">
          <div style="margin-top: 10px">
            <div style="width: 100%;text-align: right;display: flex">心率HR(次/分)
              <span style="color: #b0b0b0;margin-left: 10px"> 注：没有请填写“无”</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;">
              <a-input
                  v-model="dataForm.template_content.resident_admit_note.hr"
                  style="width: 80%"
                  placeholder="请输入初始检查结果"
              />
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="width: 100%;text-align: right;display: flex">血压BP(mmHg)
              <span style="color: #b0b0b0;margin-left: 10px"> 注：没有请填写“无”</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;">
              <a-input
                  v-model="dataForm.template_content.resident_admit_note.bp"
                  style="width: 80%"
                  placeholder="请输入初始检查结果"
              />
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="width: 100%;text-align: right;display: flex">体温T(°C)
              <span style="color: #b0b0b0;margin-left: 10px"> 注：没有请填写“无”</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;">
              <a-input
                  v-model="dataForm.template_content.resident_admit_note.temperature"
                  style="width: 80%"
                  placeholder="请输入初始检查结果"
              />
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="width: 100%;text-align: right;display: flex">脉搏P(次/分)
              <span style="color: #b0b0b0;margin-left: 10px"> 注：没有请填写“无”</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;">
              <a-input
                  v-model="dataForm.template_content.resident_admit_note.pulse"
                  style="width: 80%"
                  placeholder="请输入初始检查结果"
              />
            </div>
          </div>
          <div style="margin-top: 10px">
            <div style="width: 100%;text-align: right;display: flex">呼吸R(次/分)
              <span style="color: #b0b0b0;margin-left: 10px"> 注：没有请填写“无”</span>
            </div>
            <div style="margin-left: 10px;margin-top: 10px;">
              <a-input
                  v-model="dataForm.template_content.resident_admit_note.breathe"
                  style="width: 80%"
                  placeholder="请输入初始检查结果"
              />
            </div>
          </div>
          <div style="display: flex;margin-top: 10px;margin-left: -15px">
            <div style="width: 100px;text-align: right">是否进行消融:</div>
            <div style="margin-left: 10px">
              <a-radio-group
                  v-model="dataForm.template_content.resident_admit_note.is_Melt"
                  :options="quest_is_Melt" />
            </div>
          </div>
        </div>


        <div style="display: flex;width: 100%;margin-top: 20px">
          <div style="margin-left: 30px;display: flex">
            医嘱用药信息
          </div>
        </div>
        <div style="width: 100%;margin-top: 20px;margin-left: 70px">
          <div style="display: flex;margin-top: 10px">
            <div style="width: 100px;text-align: right">初始使用时间:</div>
            <div style="margin-left: 10px">
              <a-date-picker
                  :allowClear="false"
                  v-model="dataForm.template_content.prescribed_medication.start_time"
                  style="width: 300px;margin-left: 10px"
                  placeholder="Select month"
                  @change="startChange" />
            </div>
          </div>
          <div style="display: flex;margin-top: 10px">
            <div style="width: 100px;text-align: right">结束用药时间:</div>
            <div style="margin-left: 10px">
              <a-date-picker
                  :allowClear="false"
                  v-model="dataForm.template_content.prescribed_medication.end_time"
                  style="width: 300px;margin-left: 10px"
                  placeholder="Select month"
                  @change="endChange" />
            </div>
          </div>
          <div style="display: flex;margin-top: 10px">
            <div style="width: 100px;text-align: right">使用方法:</div>
            <div style="margin-left: 10px">
              <a-radio-group
                  v-model="dataForm.template_content.prescribed_medication.asle_use_method"
                  :options="quest_asle_use_method" />
            </div>
          </div>
          <div style="display: flex;margin-top: 10px">
            <div style="width: 100px;text-align: right">使用剂量范围:</div>
            <div style="margin-left: 10px;display: flex">
              <a-input
                  placeholder="最小剂量（mg/h）"
                  v-model="partition.Using_the_total.small"
                  style="width: 148px"/>
              <span> ~ </span>
              <a-input
                  placeholder="最大剂量（mg/h）"
                  v-model="partition.Using_the_total.big"
                  style="width: 148px"/>
            </div>
          </div>
          <div style="display: flex;margin-top: 10px">
            <div style="width: 100px;text-align: right">使用总量:</div>
            <div style="margin-left: 10px">
              <a-input
                  v-model="dataForm.template_content.prescribed_medication.total"
                  style="width: 300px"
                  placeholder="请输入使用总量(mg)"
              />
            </div>
          </div>
        </div>
        <div style="width: 100%;margin-top: 20px">
          <div style="margin-left: 80px;">
            <div>合并用药情况 :</div>
            <a-checkbox-group
                v-model="dataForm.template_content.prescribed_medication.combination_medication"
                style="width: 350px;margin-left: 80px"
                @change="checkboxChange">
              <a-row>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="乌拉地尔">
                    乌拉地尔
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="硝普钠">
                    硝普钠
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="地尔硫卓">
                    地尔硫卓
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="右美托咪定">
                    右美托咪定
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="胺碘酮">
                    胺碘酮
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="维拉帕米">
                    维拉帕米
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                <a-checkbox value="⻄地兰">
                  ⻄地兰
                </a-checkbox>
              </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="米力农">
                    米力农
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="左西孟旦">
                    左西孟旦
                  </a-checkbox>
                </a-col>
                <a-col :span="24" style="margin-top: 10px;">
                  <a-checkbox value="无以上合并用药">
                    无以上合并用药
                  </a-checkbox>
                </a-col>
              </a-row>
            </a-checkbox-group>
          </div>
        </div>
        <div style="display: flex;width: 100%;margin-top: 20px">
          <div style="margin-left: 30px;display: flex">
            病程记录+化验结果信息
          </div>
        </div>
        <div style="margin-top: 20px;margin-left: 50px">
          <div style="display: flex">
            心率HR(次/分)
            <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
          </div>
          <div style="display: flex;margin-top: 10px">
            <a-input
                v-model="partition.heart.start"
                placeholder="开始使用艾司洛尔时" style="width: 45%"/>
            <a-input
                v-model="partition.heart.end"
                placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px">
          <div style="display: flex">
            血压BP(mmHg)
            <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
          </div>
          <div style="display: flex;margin-top: 10px">
            <a-input
                v-model="partition.str_BP.start"
                placeholder="开始使用艾司洛尔时" style="width: 45%"/>
            <a-input
                v-model="partition.str_BP.end"
                placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px">
          <div style="display: flex">
            体温T(°C)
            <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
          </div>
          <div style="display: flex;margin-top: 10px">
            <a-input
                v-model="partition.str_t.start"
                placeholder="开始使用艾司洛尔时" style="width: 45%"/>
            <a-input
                v-model="partition.str_t.end"
                placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px">
          <div style="display: flex">
            血肌酐(umol/L)
            <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
          </div>
          <div style="display: flex;margin-top: 10px">
            <a-input
                v-model="partition.umol.start"
                placeholder="开始使用艾司洛尔时" style="width: 45%"/>
            <a-input
                v-model="partition.umol.end"
                placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px">
        <div style="display: flex">
          BNP/NT-ProBNP
          <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
        </div>
        <div style="display: flex;margin-top: 10px">
          <a-input
              v-model="partition.ProBNP.start"
              placeholder="开始使用艾司洛尔时" style="width: 45%"/>
          <a-input
              v-model="partition.ProBNP.end"
              placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
        </div>
      </div>
        <div style="margin-top: 10px;margin-left: 50px">
          <div style="display: flex">
            肌钙蛋白I
            <span style="margin-left: 10px;color: #b2b2b2;font-size: 12px">注：没有请填写“无”</span>
          </div>
          <div style="display: flex;margin-top: 10px">
            <a-input
                v-model="partition.str_i.start"
                placeholder="开始使用艾司洛尔时" style="width: 45%"/>
            <a-input
                v-model="partition.str_i.end"
                placeholder="结束使用艾司洛尔时" style="width: 45%;margin-left: 30px"/>
          </div>
        </div>

        <div style="display: flex;margin-top: 10px;margin-left: 50px">
          <div >患者转归:</div>
          <div style="margin-left: 10px">
            <a-radio-group
                v-model="dataForm.template_content.progress_note.patient_transition"
                :options="quest_adverse_reaction_detail" />
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px;display: flex">
          <div>
            不良反应:
          </div>
          <div style="margin-left: 10px">
            <a-radio-group
                v-model="dataForm.template_content.progress_note.is_adverse_reaction"
                :options="quest_is_adverse_reaction" />
          </div>
        </div>
        <div style="margin-top: 10px;margin-left: 50px;margin-bottom: 20px">
          <a-input
              v-model="dataForm.template_content.progress_note.adverse_reaction_detail"
              placeholder="请描述具体情况及措施"
              style="width: 80%"/>
        </div>
      </div>
    </div>
    <div style="height: 50px"></div>
    <div class="footer-div">
      <div class="footer-div-btn">
        <a-button @click="returnBtn">返回上一层</a-button>
        <a-button
            v-show="!passValue"
            style="margin-left: 10px"
            @click="unPassBtn">驳回</a-button>
        <a-button
            v-show="!passValue"
            @click="passBtn"
            style="margin-left: 10px"
            type="primary">通过</a-button>
      </div>
    </div>
    <!------------------------------------------------对话框----------------------------------------------------->
    <a-modal
        v-model="visible"
        width="700px"
        title="审批">
      <template slot="footer">
        <a-button @click="quxiaoModel">
          取消
        </a-button>
        <a-button type="primary"  @click="overruleModel">
          确定
        </a-button>
      </template>
      <div style="width: 100%;display: flex">
        <div style="width:20%;text-align: right;font-weight: bold;color: black">驳回原因 :</div>
         <a-checkbox-group
             v-model="checkboxVal"
             @change="checkbox_group_onChange"
             style="margin-left: 10px;width: 600px;">
           <a-row>
             <a-col style="margin-bottom: 8px" :span="24" v-for="(overRule,index) in overRules">
               <a-checkbox
                   :value="overRule">
                 {{overRule}}
               </a-checkbox>
             </a-col>
           </a-row>
         </a-checkbox-group>
      </div>
      <a-textarea
          style="width:500px;margin-left: 120px;margin-top: 10px;"
          v-model="overruleValue"
          placeholder="请输入其他驳回原因"
          :auto-size="{ minRows: 6, maxRows: 10 }"
      />
    </a-modal>
  </div>
</template>

<script>

import moment from "moment";
import {
  getCaseMessage,
  getCaseMessage_course,
  putCaseGo,
  putSex,
  TemplateIdRepeatHospitalNumber
} from "../../../service/case_api";

export default {
  data(){
    return{
      lenghtImage:'',
      checkboxVal:[],
      overRules:[],
      passBtnVal:true,
      dateFormatList:'YYYY-MM-DD',
      router_id:'',
      sexData:'',
      caseDetail:[],
      value:1,
      overruleValue:'',
      valueAge:20,
      visible:false,
      srcTest:'https://questionnaire.yunicu.com/#/esmolol/m',
      questSex : [
        { label: '男', value: 1 },
        { label: '女', value: 2 },
      ],
      questAnotherHospital : [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
      quest_is_hypertension : [
        { label: '否', value: '否' },
        { label: '是', value: '是'},
      ],
      //转院
      quest_is_perioperative_period: [
        { label: '否', value: '否' },
        { label: '是', value: '是' },
      ],
      questChest  : [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
      quest_is_Melt  : [
        { label: '否', value: '否' },
        { label: '是', value: '是' },
      ],
      quest_is_adverse_reaction  : [
        { label: '有', value: '有' },
        { label: '无', value: '无' },
      ],
      quest_asle_use_method  : [
        { label: '持续不间断使用', value: '持续不间断使用' },
        { label: '持续间断使用', value: '持续间断使用' },
      ],
      questisUse  : [
        { label: '否', value: 0 },
        { label: '是', value: 1 },
      ],
      quest_adverse_reaction_detail  : [
        { label: '好转', value:'好转' },
        { label: '未愈', value: '未愈' },
        { label: '死亡', value: '死亡' },
      ],
      SexPerson : [
        { label: '男', value: 1 },
        { label: '女', value: 2 },
      ],

      //审核状态
      state:'',
      ageData:'',

      dataForm:{
        "template_content":{
        //   //病程记录+化验结果
          "progress_note": {},
        //   //入院记录
          "resident_admit_note": {},
        //   //医嘱用药
          "prescribed_medication": {},
        },
      },

      partition:{
        //使用总量
        Using_the_total:{
          small:'',
          big:'',
        },
        //心率HR(次/分
        heart:{
          start:'',
          end:'',
        },
        //bp
        str_BP:{
          start:'',
          end:'',
        },
        //体温T(℃)
        str_t:{
          start:'',
          end:'',
        },
        //血肌酐（umol/L)
        umol:{
          start:'',
          end:'',
        },
        //BNP/NT-ProBNP
        ProBNP:{
          start:'',
          end:'',
        },
        //肌钙蛋白I
        str_i:{
          start:'',
          end:'',
        },
        str_arrhythmia_type:[],
        str_types_of_cd:[],
        str_combination_medication:[],
      }
    }
  },
  async created() {
    await this.getCase()
    await this.partitionData()
    await this.getCaseCourse()
  },
  computed:{
    passValue(){
      return this.$store.state.passBtn
    },
  },
  methods:{
    //获取数据
    async getCase() {
      let id = this.$route.query.id
      const response = await getCaseMessage(id)
      if(response.code === 0){
        this.dataForm = response.data
        this.state = response.data.audit_status
        this.overruleValue = response.data.reject_reason
        await this.partitionData()
      }else {
        this.$message.warning(response.message)
      }
      this.lenghtImage = this.dataForm.coding_image_list.length
    },
    //获取驳回原因
    async getCaseCourse() {
      let id = this.$route.query.templeteId
      const response = await getCaseMessage_course(id)
      if(response.code === 0){
        this.overRules = response.data.remark
      }else {
        this.$message.warning(response.message)
      }
    },
    //分割数据
    partitionData(){
      const form = this.dataForm

      //使用剂量范围
      const str_part = form.template_content.prescribed_medication.dose_range
      this.partition.Using_the_total.small = str_part.split('-')[0];
      this.partition.Using_the_total.big = str_part.split('-')[1];
      //心率HR(次/分
      const str_hr = form.template_content.progress_note.hr
      this.partition.heart.start = str_hr.split('-')[0];
      this.partition.heart.end = str_hr.split('-')[1];
      //血压BP(mmHg)
      const str_BP = form.template_content.progress_note.bp
      this.partition.str_BP.start = str_BP.split('-')[0];
      this.partition.str_BP.end = str_BP.split('-')[1];
      //体温T(℃)
      const str_t = form.template_content.progress_note.temperature
      this.partition.str_t.start = str_t.split('-')[0];
      this.partition.str_t.end = str_t.split('-')[1];

      //血肌酐（umol/L)
      const str_umol = form.template_content.progress_note.xjg
      this.partition.umol.start = str_umol.split('-')[0];
      this.partition.umol.end = str_umol.split('-')[1];
      //BNP/NT-ProBNP
      const str_ProBNP = form.template_content.progress_note.Bnp
      this.partition.ProBNP.start = str_ProBNP.split('-')[0];
      this.partition.ProBNP.end = str_ProBNP.split('-')[1];
      //肌钙蛋白I
      const str_i = form.template_content.progress_note.jgdb
      this.partition.str_i.start = str_i.split('-')[0];
      this.partition.str_i.end = str_i.split('-')[1];
    },
    //修改
    async putCase() {
      let id = this.$route.query.id
      let data = this.dataForm
      const response = await putCaseGo(id,data)
      if(response.code === 0){
        this.$message.success('修改成功')
      }else {
        this.$message.warning(response.message)
      }
    },
    //合并输入框的值
    sumForm() {
      let form = this.dataForm
      //使用剂量范围
      form.template_content.prescribed_medication.dose_range = this.partition.Using_the_total.small + '-' + this.partition.Using_the_total.big

      //心率HR(次/分
      form.template_content.progress_note.hr = this.partition.heart.start + '-' + this.partition.heart.end
      //血压BP(mmHg)
      form.template_content.progress_note.bp = this.partition.str_BP.start + '-' + this.partition.str_BP.end
      //体温T(℃)
      form.template_content.progress_note.temperature = this.partition.str_t.start + '-' + this.partition.str_t.end
      //血肌酐（umol/L)
      form.template_content.progress_note.xjg = this.partition.umol.start + '-' + this.partition.umol.end
      //BNP/NT-ProBNP
      form.template_content.progress_note.Bnp = this.partition.ProBNP.start + '-' + this.partition.ProBNP.end
      //肌钙蛋白I
      form.template_content.progress_note.jgdb = this.partition.str_i.start + '-' + this.partition.str_i.end
    },
    async passBtn() {
      let form = this.dataForm
      await this.sumForm()
      //通过
      form.audit_status = "PASSED"
      let id = this.$route.query.id
      let templeteIdY = this.$route.query.templeteId
      const reponse = await putCaseGo(id,form,templeteIdY)
      if (reponse.code === 0) {
        this.$message.success('已通过！' + reponse.message)
        //刷新
        await this.getCase()
      } else {
        this.$message.error("失败" + reponse.message)
      }
    },

    //性别
    onChange(){

    },
    //返回上一层
    returnBtn() {
      window.history.back()
    },
    unPassBtn(){
      this.visible = true
    },
    //修改性别和年龄
    async putSex(sexData,ageData){
      const id = this.$route.query.id
      const data = {
        "patientSex":parseInt(sexData),
        "birthday":ageData
      }
      const reponce = await putSex(id,data)
      if(reponce.code === 0){
        this.$message.success('修改成功！'+reponce.message)
        await this.getCase()
      }else {
        this.$message.warning(reponce.message)
      }
    },
    // 保存患者信息
    preservation(){
      const sex = parseInt(this.dataForm.patientSex)
      const age = this.ageData
      if(sex!== '' && sex !== null && sex !== undefined ||
          age!== '' && age !== null && age !== undefined){
        switch (sex){
          case 1:
            this.putSex(1,age)
            break;
          case 2:
            this.putSex(2,age)
            break;
          default:
            break;
        }
      }
    },
    //出生日期
    ageChange(date){
      const dataTime = moment(date).format('YYYY-MM-DD')
      this.ageData = dataTime
    },
    //入院选择
    hospitalizedChange(date){
      this.dataForm.template_content.resident_admit_note.admission_time = moment(date).format('YYYY-MM-DD')
    },
    operationChange(date){
      this.dataForm.template_content.resident_admit_note.operation_time = moment(date).format('YYYY-MM-DD')
    },
    startChange(date){
      this.dataForm.template_content.prescribed_medication.start_time = moment(date).format('YYYY-MM-DD')
    },
    endChange(date){
      this.dataForm.template_content.prescribed_medication.end_time = moment(date).format('YYYY-MM-DD')
    },
    checkboxChange(checkedValues){
    },
    useChange(){

    },
    finishChange(){

    },
    quxiaoModel() {
      this.visible = false;
    },
    checkbox_group_onChange(){
      this.overruleValue = this.checkboxVal.join(';')
    },
    //驳回确定按钮
    async overruleModel() {
      let form = this.dataForm
      //合并输入框的值
      await this.sumForm()
      let id = this.$route.query.id
      let templeteIdY = this.$route.query.templeteId
      form.audit_status = "DENIED"
      form.reject_reason = this.overruleValue
      const reponse = await putCaseGo(id, form,templeteIdY)
      if (reponse.code === 0) {
        this.$message.success('已驳回！' + reponse.message)
      } else {
        this.$message.error("失败，请联系管理员！！" + reponse.message)
      }
      this.visible = false
    },
  //  图片刷新
    refreshBtn(){
      this.getCase()
    },
  //  打码
    captchaBtn(){
      const userData = JSON.parse(window.localStorage.getItem("user_info"))
      // window.open(`${this.adminLink}`+ '?id=' + row.id + '&user_id=' + userData.id)
      let id = this.$route.query.id
      this.$router.push({ path: '/caseCode',query:{id:id,userId:userData.id,userName:userData.user_name}})
    },
    async examineBtn(id,member) {
      const reponse = await TemplateIdRepeatHospitalNumber(id,member)
      if (reponse.code === 0) {
        this.$message.success(reponse.message)
      } else {
        this.$message.warning( reponse.message)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.review-title{
  font-size: 22px;
  font-weight: bold;
  color: black;
  height:100px;
  line-height: 80px;
  padding-left: 30px;
  border-bottom: 10px solid #f5f5f5;
}
.review-doc{
  height:120px;
  line-height: 50px;
  border-bottom: 10px solid #f5f5f5;
  color: black;
  .review-doc-title{
    font-size: 15px;
    color: black;
    font-weight: bold;
    padding-left: 30px;
    border-bottom: 2px solid #f5f5f5;
  }
  .review-doc-content{
    width: 100%;
    display: flex;
    color: black;
    .review-doc-content-font{
      width: 30%;
      padding-left: 30px;
      color: black;
    }
  }
}

.review-huan{
  height:150px;
  line-height: 50px;
  border-bottom: 10px solid #f5f5f5;
  color: black;
  .review-huan-title{
    padding-left: 30px;
    border-bottom: 2px solid #f5f5f5;
    display: flex;
    color: black;
    .review-huan-title-huanzhe{
      font-size: 15px;
      color: black;
      font-weight: bold;
      width: 85%;
    }
  }
  .review-huan-content{
    width: 100%;
    display: flex;
    color: black;
    .review-huan-content-font{
      width: 30%;
      padding-left: 30px;
      padding-top: 15px;
      display: flex;
      color: black;
    }
    .review-huan-content-font-two{
      display: flex;
      width: 30%;
      padding-left: 30px;
      padding-top: 15px;
      color: black;
    }
  }
}
.review-content{
  height: auto;
  display: flex;
  //border-bottom: 10px solid #f5f5f5;
  color: black;
  .review-content-left{
    width: 50%;
    //height: 100%;
    min-height: 2000px;
    color: black;
    .review-content-left-title{
      font-size: 16px;
      height: 60px;
      line-height: 60px;
      color: black;
      font-weight: bold;
      padding-left: 30px;
      border-bottom: 2px solid #f5f5f5;
    }
    .review-content-left-font{
      font-weight: bold;
      padding-left: 30px;
      color: black;
      margin-bottom: 15px;
    }
  }
  .review-content-right{
    width: 50%;
    height: auto;
    color: black;
    border-left: 10px solid #f5f5f5;
    .review-content-right-title{
      font-size: 16px;
      height: 60px;
      line-height: 60px;
      color: black;
      font-weight: bold;
      padding-left: 30px;
      border-bottom: 2px solid #f5f5f5;
    }
    .review-content-right-title-title{
      font-weight: bold;
      padding-left: 30px;
      margin-top: 30px;
      color: black;
    }
    .review-content-right-person{
      display: flex;
      margin-bottom: 15px;
      width: 100%;
      margin-left:80px;
      color: black;
      .review-content-right-person-name{
        width: 50%;
        //margin-left: 5%;
        color: black;
      }
      .review-content-right-person-sex{
        width: 50%;
      }
    }
    .toBeMessage{
      margin-bottom: 15px;
      display: flex;
      width: 100%;
      .font{
        width: 50%;
        color: black;
      }
      .selectBtn{
        width: 50%;
        color: black;
      }
    }
    .betoMessage{
      margin-bottom: 15px;
      display: flex;
      width: 100%;
      .font{
        width: 150px;
        text-align: right;
        color: black;
      }
      .inputShu{
        width: 60%;
        margin-left: 5px;
        color: black;
      }
    }
    .mazui{
      margin-bottom: 15px;
      width: 100%;
      .font{
        margin-left: 5%;
        color: black;
      }
    }
    .mazui-input{
      margin-bottom: 15px;
      display: flex;
      width: 100%;
      color: black;
      .mazui-input-one{
        width: 24%;
        text-align: center;
        color: black;
      }
    }
    .inputWitch{
      width: 60%;
      color: black;
    }
  }
}
.footer-div{
  width: 100%;
  height: 50px;
  background-color: #f0f2f5;
  position: fixed;
  bottom: 0;
  border-bottom: 1px solid #fff;
  .footer-div-btn{
    display: flex;justify-content: right;
    width: 82%;
    margin-top: 8px;
  }
}
</style>
